import graphql__7492bc716e2a71795142 from "./__generated__/AuthenticationModalMethods_authenticationConfig.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";

import AuthenticationSignIn from "./AuthenticationSignIn";
import AuthenticationSignUp from "./AuthenticationSignUp";
import AuthenticationAnonymousUserForm from "./AuthenticationAnonymousUserForm";
import AuthenticationCollapsibleForm from "./AuthenticationCollapsibleForm";
import { useFormatMessage } from "../Intl/Context";
import AuthenticationSamlForm from "./AuthenticationSamlForm";
import AuthenticationOpenidForm from "./AuthenticationOpenidForm";

const AuthenticationModalMethods = props => {
  const authenticationConfig = useFragment(
    AuthenticationModalMethods_authenticationConfig,
    props.authenticationConfig
  );

  const { authenticationModal } = authenticationConfig;
  const { displayOpenid, displaySaml, displaySignIn, displaySignUp } =
    authenticationModal;

  const { onSignIn, viewer, authorizeAnonymousUserAuth, authenticationAdditionalProps } =
    props;

  const t = useFormatMessage();
  const displayAnonymousUserAuthentication = !!authorizeAnonymousUserAuth;

  return (
    <>
      {displaySaml &&
        authenticationConfig.samlAuthServices?.map(samlAuth => (
          <AuthenticationSamlForm
            key={samlAuth.id}
            samlAuth={samlAuth}
            className="margin-bottom-xs"
          />
        ))}

      {displayOpenid &&
        authenticationConfig.openidAuthServices?.map(openidAuth => (
          <AuthenticationOpenidForm
            key={openidAuth.id}
            openidAuth={openidAuth}
            className="margin-bottom-xs"
          />
        ))}

      {displayAnonymousUserAuthentication && (
        <AuthenticationCollapsibleForm
          type="anonymous"
          label={t(intlMessages.anonymousOption)}
        >
          <AuthenticationAnonymousUserForm
            onSignIn={onSignIn}
            viewer={viewer}
            authenticationConfig={authenticationConfig}
            authenticationAdditionalProps={authenticationAdditionalProps}
          />
        </AuthenticationCollapsibleForm>
      )}

      {displaySignIn && (
        <AuthenticationCollapsibleForm type="signIn" label={t(intlMessages.signInOption)}>
          <AuthenticationSignIn
            onSignIn={onSignIn}
            authenticationConfig={authenticationConfig}
          />
        </AuthenticationCollapsibleForm>
      )}

      {displaySignUp && (
        <AuthenticationCollapsibleForm type="signUp" label={t(intlMessages.signUpOption)}>
          <AuthenticationSignUp
            onSignIn={onSignIn}
            authenticationConfig={authenticationConfig}
          />
        </AuthenticationCollapsibleForm>
      )}
    </>
  );
};

const AuthenticationModalMethods_authenticationConfig = graphql__7492bc716e2a71795142;

export default AuthenticationModalMethods;

const intlMessages = defineMessages({
  anonymousOption: {
    id: "authentication.option.anonymous",
    defaultMessage: "Continuer sans compte"
  },
  signInOption: {
    id: "authentication.option.signIn",
    defaultMessage: "Se connecter avec un compte"
  },
  signUpOption: {
    id: "authentication.option.signUp",
    defaultMessage: "Créer un compte"
  }
});
